import { Navigate, type RouteObject } from "react-router";

import { TEAM_SECTION_PERMISSIONS } from "@/app/session/permissions";
import { RequireCapability } from "@/app/session/RequireCapability";
import { FullScreenLoader } from "@/app/session/RequireSession";

/* The people area: team, clients and the person's own settings, inside the app shell. Each
   section is hidden (404) from people without its permission, as the server does. */
export const peopleRoutes: RouteObject[] = [
  {
    element: <RequireCapability permission={TEAM_SECTION_PERMISSIONS} />,
    children: [
      {
        path: "team",
        lazy: async () => ({
          Component: (await import("@/features/team/routes/TeamLayout")).default,
        }),
        children: [
          {
            index: true,
            lazy: async () => ({
              Component: (await import("@/features/team/routes/TeamIndex")).default,
            }),
          },
          {
            element: <RequireCapability permission={["team.view", "departments.manage"]} />,
            children: [
              {
                path: "departments",
                lazy: async () => ({
                  Component: (await import("@/features/team/routes/DepartmentsTab")).default,
                }),
              },
            ],
          },
          {
            element: <RequireCapability permission="team.view" />,
            children: [
              {
                path: "roles",
                lazy: async () => ({
                  Component: (await import("@/features/team/routes/RolesTab")).default,
                }),
              },
            ],
          },
          {
            element: <RequireCapability permission="audit.view" />,
            children: [
              {
                path: "activity",
                lazy: async () => ({
                  Component: (await import("@/features/team/routes/ActivityTab")).default,
                }),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    element: <RequireCapability permission="clients.view" />,
    children: [
      {
        path: "clients",
        lazy: async () => ({
          Component: (await import("@/features/clients/routes/ClientsPage")).default,
        }),
      },
      {
        path: "clients/:clientId",
        lazy: async () => ({
          Component: (await import("@/features/clients/routes/ClientLayout")).default,
        }),
        children: [
          {
            index: true,
            lazy: async () => ({
              Component: (await import("@/features/clients/routes/ClientOverviewTab")).default,
            }),
          },
          {
            path: "projects",
            lazy: async () => ({
              Component: (await import("@/features/clients/routes/ClientProjectsTab")).default,
            }),
          },
        ],
      },
    ],
  },
  { path: "settings", element: <Navigate to="/settings/profile" replace /> },
  {
    path: "settings/profile",
    lazy: async () => ({
      Component: (await import("@/features/profile/routes/ProfilePage")).default,
    }),
  },
];

/* Public: someone invited opens their link before they have an account. */
export const invitationRoute: RouteObject = {
  path: "/invitation",
  hydrateFallbackElement: <FullScreenLoader />,
  lazy: async () => ({
    Component: (await import("@/features/invitations/routes/AcceptInvitationPage")).default,
  }),
};
